import type * as React from "react"

import { cn } from "@/lib/utils"

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-bone placeholder:text-bone-dim selection:bg-red bg-bg-input border-border text-bone flex h-9 w-full min-w-0 rounded-lg border px-3 py-1 text-base shadow-[inset_0_1px_2px_rgba(0,0,0,0.2)] transition-[color,box-shadow] outline-none selection:text-white file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-red-bright focus-visible:bg-bg-hover focus-visible:ring-red-dim focus-visible:ring-[4px]",
        "aria-invalid:ring-red-dim aria-invalid:border-red-bright",
        className,
      )}
      {...props}
    />
  )
}

export { Input }
